import {CookiesProvider} from 'react-cookie'
import PropTypes from 'prop-types'
import {
  Box,
  CloseButton,
  Flex,
  Text,
  useBreakpointValue,
} from '@chakra-ui/react'
import {LogoHorizontal, LogoSymbol} from '../../components'

const FullScreenModalLayout = ({children, title, onClose}) => {
  const mobileBreakpoint = 'md'
  const mobileView = useBreakpointValue({
    base: true,
    [mobileBreakpoint]: false,
  })

  return (
    <CookiesProvider>
      <Box>
        <Flex
          px={{base: 'sm', [mobileBreakpoint]: 'md'}}
          py="sm"
          justifyContent="space-between"
          alignItems="center"
          borderBottom="0.5px solid"
          borderColor="mld.neutral.900"
          position="sticky"
          top="0"
          bg="white"
        >
          {mobileView ? (
            <LogoSymbol maxH="18px" maxW="23px" />
          ) : (
            <LogoHorizontal maxH="18px" maxW="157px" />
          )}
          <Text
            as="h2"
            position="sticky"
            left="50%"
            transform="translateX(-50%)"
            textStyle="headline4"
            textAlign="center"
          >
            {title}
          </Text>
          <CloseButton onClick={onClose} />
        </Flex>
        <Box backgroundColor="mld.neutral.50">{children}</Box>
      </Box>
    </CookiesProvider>
  )
}

FullScreenModalLayout.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
}

export default FullScreenModalLayout
